module.exports = __webpack_public_path__ + "static/media/cocacola.55e673dd.PNG";